// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const turtonator: PokeData = {
  "id": 776,
  "name": "turtonator",
  "height": 20,
  "weight": 2120,
  "base_experience": 170,
  "types": [
    PokeType.FIRE,
    PokeType.DRAGON
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "ember",
    "flamethrower",
    "smog",
    "explosion",
    "flail",
    "protect",
    "endure",
    "overheat",
    "iron-defense",
    "dragon-pulse",
    "shell-smash",
    "incinerate",
    "shell-trap"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "ember",
    "flamethrower",
    "protect",
    "dragon-pulse",
    "dragon-vortex",
    "fire-fang",
    "great-roar",
    "sunny-day",
    "dragon-rush",
    "draco-meteor",
    "magma-storm"
  ],
  "evolution_chain": {
    "id": 402,
    "item": null,
    "species": [
      {
        "name": "turtonator",
        "order": 776,
        "types": [
          PokeType.FIRE,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 160,
    "speed": 68,
    "ability_power": 172
  },
  "stat_changes": [],
  "catch_rate": 70,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
